import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const hostname = window.location.hostname;

  // Determine environment flags
  const isLocal = hostname === "localhost";
  const isDev = hostname.includes("dev");
  const isStg = hostname.includes("stg");
  const prodOnly = !isLocal && !isDev && !isStg;

  // Determine baseUrl based on the environment
  const baseUrl = isLocal
    ? "https://mdcreactdev.wpenginepowered.com"
    : isDev
    ? "https://mdcreactdev.wpenginepowered.com"
    : isStg
    ? "https://mdcreactstg.wpenginepowered.com"
    : "https://mdcreact.wpenginepowered.com";

  // Initialize context object
  const [contextObject, setContextObject] = useState({
    baseUrl,
    isLocal,
    prodOnly,
    purchaseCountry: "",
    dealerName: "",
  });

  return (
    <AppContext.Provider value={{ contextObject, setContextObject }}>
      {children}
    </AppContext.Provider>
  );
};
